export default __webpack_public_path__ + "static/media/mail-icon.0525c1fa.svg";